import { render, staticRenderFns } from "./BulbSettings.vue?vue&type=template&id=10a48600"
import script from "./BulbSettings.vue?vue&type=script&lang=js"
export * from "./BulbSettings.vue?vue&type=script&lang=js"
import style0 from "./BulbSettings.vue?vue&type=style&index=0&id=10a48600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../microservices/playlist/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports